import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Dropdown } from 'react-bootstrap';
import { clear } from '../../store/reducers/authReducer';

export const UserMenu = ({ user }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(clear());
        navigate('/');
    };

    return (
        <Dropdown>
            <Dropdown.Toggle variant="primary" id="user-dropdown">
                {user.name}&nbsp;
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {user.role == 'admin' && (
                    <Dropdown.Item onClick={() => navigate('/admin')}>Dashboard</Dropdown.Item>
                )}
                <Dropdown.Item onClick={() => navigate('/user')}>Profile</Dropdown.Item>
                <Dropdown.Item onClick={() => navigate('/user/orders')}>Orders</Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
